 
import './App.css';
import Home from './components/pages/Home.jsx';


function App() {
  return (
    <div className="App">
      <Home /> 
      
    </div>
  );
}

export default App;
